import type { FormatRaportu } from "./api.js";

/**
 * Nazwa pliku z naglowka Content-Disposition odpowiedzi serwera (czysta funkcja).
 *
 * Serwer nadaje raportowi nazwe ASCII `raport-oceny-<8 znakow id>-<RRRRMMDD>.docx` (albo `.pdf`) bez tresci rozmowy,
 * wiec zwykle wystarczy `filename="..."`. Obslugujemy tez `filename=...` bez cudzyslowow i `filename*=UTF-8''...`
 * (RFC 5987), a wynik czyscimy: bez sciezek i znakow sterujacych, zawsze z rozszerzeniem pobieranego formatu.
 */

export const NAZWA_RAPORTU_DOMYSLNA = "raport-oceny.docx";

/** Nazwa, gdy serwer nie podal zadnej (albo podal smieci): rozszerzenie zawsze zgodne z pobieranym formatem. */
function nazwaDomyslna(format: FormatRaportu): string {
  return `raport-oceny.${format}`;
}

function oczysc(nazwa: string, format: FormatRaportu): string | null {
  // Tylko ostatni element sciezki, bez znakow sterujacych i znakow zabronionych w nazwach plikow.
  const koncowka = nazwa.split(/[\\/]/).pop() ?? "";
  const bezSmieci = [...koncowka]
    .filter((znak) => znak.charCodeAt(0) >= 0x20 && znak.charCodeAt(0) !== 0x7f && !'<>:"|?*'.includes(znak))
    .join("")
    .trim();
  if (bezSmieci.length === 0 || bezSmieci === "." || bezSmieci === "..") return null;
  return bezSmieci.toLowerCase().endsWith(`.${format}`) ? bezSmieci : `${bezSmieci}.${format}`;
}

export function nazwaPlikuZNaglowka(naglowek: string | null, format: FormatRaportu = "docx"): string {
  if (!naglowek) return nazwaDomyslna(format);

  const rozszerzona = /filename\*\s*=\s*(?:[A-Za-z0-9-]+)'[^']*'([^;]+)/i.exec(naglowek)?.[1]?.trim();
  if (rozszerzona) {
    try {
      const nazwa = oczysc(decodeURIComponent(rozszerzona), format);
      if (nazwa) return nazwa;
    } catch {
      // Zle kodowanie procentowe: probujemy zwyklego filename.
    }
  }

  const zwykla = /filename\s*=\s*(?:"([^"]*)"|([^;]+))/i.exec(naglowek);
  const wartosc = (zwykla?.[1] ?? zwykla?.[2] ?? "").trim();
  return oczysc(wartosc, format) ?? nazwaDomyslna(format);
}
